import type { ReactNode } from 'react';
import { Alert, Button, LoadingBlock } from '../components/ui.tsx';
import { WorkPage, WorkSection } from '../components/work-page.tsx';
import './portal-page.css';

/** Read-only leaf feedback; session, permission and mutation guards stay with their owners. */
export function PortalReadState({
  title,
  label,
  error,
  retry,
  children,
}: {
  title: string;
  label?: string;
  error?: string;
  retry?: () => unknown;
  children?: ReactNode;
}) {
  return (
    <div className="portal-page">
      <WorkPage title={title}>
        <WorkSection title={error ? 'Please try again' : 'Getting things ready'}>
          {error ? <Alert tone="error">{error}</Alert> : <LoadingBlock label={label} />}
          {error && retry ? (
            <Button className="mt-4" onClick={() => void retry()}>
              Try again
            </Button>
          ) : null}
          {children}
        </WorkSection>
      </WorkPage>
    </div>
  );
}
